import { render, staticRenderFns } from "./GeneralCampusPortalIdRedirector.vue?vue&type=template&id=561a659e&scoped=true&"
import script from "./GeneralCampusPortalIdRedirector.vue?vue&type=script&lang=ts&"
export * from "./GeneralCampusPortalIdRedirector.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralCampusPortalIdRedirector.vue?vue&type=style&index=0&id=561a659e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a659e",
  null
  
)

export default component.exports